// Magenta-pink dot (M42 hydrogen-alpha color) marking the active speaking moment
// — shown only on a still-typing assistant bubble.
export function StreamingCursor() {
  return <span aria-hidden style={CURSOR} />;
}

const CURSOR: React.CSSProperties = {
  display: 'inline-block',
  width: 7,
  height: '0.95em',
  marginInlineStart: 3,
  verticalAlign: '-2px',
  background: 'linear-gradient(180deg, var(--accent-glow-soft-solid) 0%, var(--accent-glow-solid) 100%)',
  borderRadius: 2,
  boxShadow: '0 0 12px rgba(var(--accent-glow-rgb),0.65)',
  animation: 'typing-dot 1.1s ease-in-out infinite',
};
